import { render, staticRenderFns } from "./sip-yes-no.vue?vue&type=template&id=49f4fe45"
import script from "./sip-yes-no.vue?vue&type=script&lang=js"
export * from "./sip-yes-no.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f4fe45')) {
      api.createRecord('49f4fe45', component.options)
    } else {
      api.reload('49f4fe45', component.options)
    }
    module.hot.accept("./sip-yes-no.vue?vue&type=template&id=49f4fe45", function () {
      api.rerender('49f4fe45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/sip-yes-no.vue"
export default component.exports